
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, record_type, string_type, list_type, bool_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ActivatedEmailNotification_$reflection, User_$reflection } from "../Shared/User.js";
import { ClientApiResponse$1_$reflection, RemoteValue$1_$reflection } from "../Shared/Shared.js";
import { Storage_$reflection } from "../Shared/Storage.js";
import { SavedAvailabilityView_$reflection } from "../Shared/Availability.js";

export class State extends Record {
    constructor(Message, User, Storages, SavedAvailabilityViews, DashboardViewNames) {
        super();
        this.Message = Message;
        this.User = User;
        this.Storages = Storages;
        this.SavedAvailabilityViews = SavedAvailabilityViews;
        this.DashboardViewNames = DashboardViewNames;
    }
}

export function State_$reflection() {
    return record_type("Profile.Types.State", [], State, () => [["Message", bool_type], ["User", RemoteValue$1_$reflection(User_$reflection())], ["Storages", RemoteValue$1_$reflection(list_type(Storage_$reflection()))], ["SavedAvailabilityViews", RemoteValue$1_$reflection(list_type(SavedAvailabilityView_$reflection()))], ["DashboardViewNames", list_type(string_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SendResetPassword", "ChangeLanguage", "PasswordResetSent", "UserLanguageUpdated", "ChangeEmailNotification", "ChangeNewsletterConsent", "UserFetched", "UpdateUser", "UserEmailNotificationUpdated", "NewsletterConsentUpdated", "StoragesFetched", "SavedAvailabilityViewsFetched", "ChangeDashboardViews", "SaveDashboardViews", "DashboardViewsSaved", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("Profile.Types.Msg", [], Msg, () => [[], [["Item", string_type]], [["Item", string_type]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ActivatedEmailNotification_$reflection()]], [["Item", bool_type]], [["Item", User_$reflection()]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(Storage_$reflection())]], [["Item", list_type(SavedAvailabilityView_$reflection())]], [["Item", list_type(string_type)]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", class_type("System.Exception")]]]);
}

